import dynamic from 'next/dynamic';
const Recirculation = dynamic(() => import('./Recirculation'));

export { Recirculation };
